import AccesoRapido from "./accesoRapido.component"
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as constant from '../../global/const';
import { useEffect, useState, useCallback, useRef } from "react";
import GridProducto from "../CardProducto/gridProductos.component";
import ScrollContainer from "react-indiana-drag-scroll";
import { useHistory } from "react-router-dom";

const GridAccesoRapido = (props) => {

    const sucursal = useSelector(state => state.page.sucursal);
    const [mostrarProductos, setMostrarProductos] = useState(false);
    const [tipo, setTipo] = useState("");
    const [ar, setAr] = useState([]);
    const { open, setOpen } = props;
    let history = useHistory();

    //Input Prueba
    const input = useRef(null);
    const onClickInput = useCallback(event => {
        if (event.target.tagName === "INPUT") {
        input.current = event.target;
        event.target.focus();
        } else {
        if (input.current) {
            input.current.blur();
            input.current = null;
        }
        }
    }, []);

    const getAccesosRapidos = async () => {
        await axios.get(constant.GETACCESOSRAPIDOS + `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}`)
            .then(
                (response) => {
                    setAr(response.data);
                }
            ).catch(
                (err) => {
                    console.log(err);
                }
            )
    }

    useEffect(() => {
        setMostrarProductos(false);
        (sucursal && getAccesosRapidos());
    }, [sucursal]);

    return (
        <>
            <div style={{ margin: "0% 1%", textAlign: "center" }}>
                <ScrollContainer className={"contenedor_acceso-rapido"} onClick={onClickInput}
                horizontal={true} hideScrollbars={false} nativeMobileScroll={true}>

                    <div
                        className="acceso-rapido"
                    >
                        {
                            ar.slice(0, 3).map(
                                (ar, i) => {
                                    return (
                                        <AccesoRapido
                                            key={i + ar.nombre}
                                            titulo={ar.nombre}
                                            descripcion={ar.descripcion}
                                            url={ar.url}
                                            tipo={ar.tipo}
                                            setTipo={setTipo}
                                            setMostrarProductos={setMostrarProductos}
                                            history={history}
                                            open={open}
                                            setOpen={setOpen}
                                        />)
                                }
                            )
                        }
                    </div>
                </ScrollContainer>
                {
                    (mostrarProductos && tipo !== '')
                    &&
                    <GridProducto
                        tipo={tipo}
                    />
                }
            </div>
        </>
    )
}
export default GridAccesoRapido;